import { Delete } from "lucide-react";

const apiConfig = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  loginEndpoint: "/admin/login",
  resetPasswordEndpoit: "/user/reset-password",
  addCategory: "/admin/addCategory",
  getCategory: "/admin/getcategory",
  updateCategory: "/admin/updatecategory/",
  deleteCategory: "/admin/deletecategory/",
  AddSubCategory: "/admin/addSubcategory",
  getSubCategory: "/admin/getcategory?parentId=",
  deleteSubCategory: "/admin/deletesubcategory/",
  getAllUsers: "/admin/getAllUsers",
  deleteUser: "/admin/deleteUser/",
  getAllProduct: "/user/getAllProducts",
  updateProduct: "/user/update/",
  deleteProducts: "/admin/deleteProducts/",
  addProducts: "/user/new-product",
  createOffers: "/admin/createOffers",
  getPromotinalOffers: "/user/promotionalOffers",
  deleteOffers: "/admin/deleteOffers/",
  updatePromotin: "/admin/editPromotion/",
  getAllOrders: "/admin/getAllOrders",
  SendNotification: "/admin/sendNotification",
  UploadPromotionalOfferImg: "/admin/UploadImagePromotion",
  GetPromotinalImg: "/admin/promotionalImages",
  getProductById: "/admin/getProductById/",
  AddAppNewVerion: "/admin/insertNewVersion",
  getversion: "/user/latestversion",
  ReceivedOrder: "/admin/order/status?status=received",
  Delivered: "/admin/order/status?status=delivered",
  Shipped: "/admin/order/status?status=shipped",
  Cancelled: "/admin/order/status?status=cancelled",
  Processing: "/admin/order/status?status=processing",
  Accepted: "/admin/searchByUpdateStatus/status?updateStatus=Accepted",
  NotAccepted: "/admin/searchByUpdateStatus/status?updateStatus=Not Accepted",
  GetDeliveryCost: "/admin/getDeliveryCost",
  AddDeliverCost: "/admin/deliverCost",
  updateDeliveryCost: "/admin/updateDeliveryCost",
  DeleteDeliverycost: "/admin/deleteDeliverycost",
  OrderAcceptOrReject: "/admin/order/acceptorReject",
  GetBankAllDetails: "/admin/getAlldetails",
  AddBankDetails: "/admin/addBankDetail",
  BankDetailsUpdate: "/admin/updateDetails",
  DeleteBankAccount: "/admin/deleteBankAccount",
  ViewTrendingProducts: "/user/getTrendingProduct",
  ViewTrendingProductsUpdate: `/admin/remove/trendingtag`,
  AddCoupon: "/admin/create/coupons",
  GetCoupons: "/admin/getAll/coupons",
  DeleteCoupons: "/admin/delete/coupons/",
  Reports: "/admin/statistics",

  GetAcceptedOrders: "/admin/getAcceptedOrders",
  AddBrand: "/admin/addNewBrand",
  GetAllBrands: "/admin/getNewBrands",
  UpdateBrand: "/admin/UpdateBrand",
  DeleteBrand: "/admin/deleteBrand",
  AddSpecifications: "/admin/specification-keys",
  GetAllspecificationkeys: "/admin/GetAllspecificationkeys",
  UpdateSpecifications: "/admin/specification-keys/",
  DeleteSpecifications: "/admin/deletekeys",
  AddFlashSale: "/admin/addToFlashSale",
  GetFlashSale: "/admin/getFlashSales",
  UpdateFlashSale: "/admin/updateFlashSale/",
  BulkProductUpload: "admin/upload-bulk-products",
  ReferralFeature: "/admin/addGiftProduct",
  GiftProductDetails: "/admin/getGiftProducts",
  DeleteGiftProduct: "/admin/deleteGift",
  ImageUploading: "admin/upload-images",
  GetImage: "/admin/images",
  DeleteImage: "admin/images/",
  Analytics: "/admin/analytics",
  SearchByProduct: "admin/Product",
  ProcessingData: "/admin/order/status?status=processing",
  CodData: "/admin/order/status?status=processing",
  GetAllSeller: "/admin/getSeller",
  GetSellerUpdateStatus: "/admin/apprvoeSeller",
  createCommission: "/admin/create",
  getAllCommissions: "/admin/all",
  DeleteCommission: "/admin/delete/",
  UpdateCommission: "/admin/update/",
  getAllSellerProducts: "/user/seller-products",
  filterSellerProducts: "admin/seller-products/filter",
  sellerProductAccept: "/admin/seller-products/review",
  GetSellerWallet: "/seller/get-wallet",
  DeleteSeller: "/admin/deleteSeller/",
  getProducts: "/admin/seller-products/",
  GetAdminWallet: "/user/getAdminWallet",
  ReleaseHoldAmount: "/user/release-hold-amount",
  GetSellerWithdrawalRequests: `/user/withdraw-requests`,
  GetAllReseller: "/user/getReseller",
  adminGetResellerOrders: "/user/get-reseller-orders",
  adminGetSellerOrders: "/user/get-seller-orders",
  GetResellerUpdateStatus: "/admin/approveReseller",
  DeleteReseller: "/admin/deleteReseller",
  getAllReSellerProducts: "/user/reseller-products",
  filterReSellerProducts: "/user/reseller-products/filter",
};

export default apiConfig;
